const TIMESTAMP_PATTERN = /^(\d+):([0-5]\d)$/

export const parseTimestampToSeconds = (timestamp: string): number => {
  const match = TIMESTAMP_PATTERN.exec(timestamp)
  const minutes = match?.[1]
  const seconds = match?.[2]

  if (minutes === undefined || seconds === undefined) {
    throw new Error(`Invalid timestamp "${timestamp}". Expected MM:SS.`)
  }

  return Number(minutes) * 60 + Number(seconds)
}
